const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim() || "";

const GA_SCRIPT_ID = "finu-google-analytics-tag";
const GA_LOADED_FLAG = "__finuGaLoaded";

const ensureDataLayer = () => {
  if (typeof window === "undefined") return false;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  return true;
};

export const hasGoogleAnalytics = () => Boolean(GA_MEASUREMENT_ID);

export const initGoogleAnalytics = () => {
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID) return false;

  ensureDataLayer();

  if (!window[GA_LOADED_FLAG]) {
    window[GA_LOADED_FLAG] = true;

    const existingScript = document.getElementById(GA_SCRIPT_ID);
    if (!existingScript) {
      const script = document.createElement("script");
      script.id = GA_SCRIPT_ID;
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      document.head.appendChild(script);
    }
  }

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
  });

  return true;
};

export const trackPageView = ({
  page_path,
  page_location,
  page_title = document.title,
} = {}) => {
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID) return;

  ensureDataLayer();
  window.gtag("event", "page_view", {
    page_path: page_path || window.location.pathname + window.location.search,
    page_location: page_location || window.location.href,
    page_title,
  });
};

export const setGoogleAnalyticsUserId = (userId) => {
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID || !userId) return;

  ensureDataLayer();
  window.gtag("set", { user_id: String(userId) });
};
